import React from "react";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useFormatDateHook } from "hooks";
import {
  useDealActions,
  useDealFormDealIdSelect,
  useDealFormIdSelect,
  useDealFormLastVisitSelect,
  useRequestRefreshDealFormSelect
} from "store";
import { DealFormFilter } from "store/types";

interface Props {
  filterValue: DealFormFilter;
}

export const UpdateBar: React.FC<Props> = ({ filterValue }) => {
  const { getDealFormAndStoreAction, setRefreshDealForm } = useDealActions();

  const refreshDealForm: boolean = useRequestRefreshDealFormSelect();
  const lastVisit = useDealFormLastVisitSelect();
  const dealFormDealId = useDealFormDealIdSelect();
  const dealFormId = useDealFormIdSelect();

  const formatDate = useFormatDateHook();

  const isRefreshActive = refreshDealForm || Boolean(lastVisit);

  if (!isRefreshActive) return;

  const showMessage = () => {
    let result = "";
    if (lastVisit) {
      result = "The form is filtered to show changes since you last viewed it on";
    }

    if (refreshDealForm) {
      result = "The form has changed, please refresh to see changes";
    }

    if (lastVisit) {
      result += ` ${formatDate({ date: lastVisit, format: "HH:mm, MMM DD, YYYY" })}`;
    }

    return result;
  };

  return (
    <Stack
      direction="row"
      sx={{
        flexShrink: 0,
        maxHeight: "100%",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "space-between",
        height: 60,
        bgcolor: "#68babf",
        p: "0 20px",
        width: "100%"
      }}
    >
      <Typography sx={{ fontSize: "16px", color: "white" }}>{showMessage()}</Typography>
      <Stack flexDirection="row" sx={{ justifyContent: "center", alignItems: "center" }} gap="10px">
        {!lastVisit && (
          <Button
            sx={{ color: "white", borderColor: "white" }}
            variant="outlined"
            onClick={() => {
              if (!dealFormDealId) return;
              if (!dealFormId) return;
              getDealFormAndStoreAction({
                dealId: dealFormDealId,
                formId: dealFormId,
                filter: filterValue.name,
                disableLoading: true
              });
              setRefreshDealForm(false);
            }}
          >
            Refresh
          </Button>
        )}
        <IconButton onClick={() => setRefreshDealForm(false)}>
          <CloseOutlinedIcon sx={{ fill: "white", fontSize: "18px", cursor: "pointer" }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
